"use client";
import React, { useState } from "react";
import ContactModal from "./ContactModal";
import "./Hero.css";

export default function Hero() {
  const [showContact, setShowContact] = useState(false);

  return (
    <>
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-image"></div>

        <div className="hero-overlay">
          <div className="hero-left">
            <h2>SAGAR DESAI</h2>
            <p className="hero-location">LONDON, ENG</p>
          </div>

          <div className="hero-right">
            <button
              className="contact-btn"
              onClick={() => setShowContact(true)}
            >
              CONTACT ME
            </button>
          </div>
        </div>
      </section>

      {/* CONTACT MODAL */}
      <ContactModal open={showContact} onClose={() => setShowContact(false)} />
    </>
  );
}
